// LedgerAffiliateCTA — TopWallet affiliate CTA block.
// variant="full"    → 3 productos (Nano S Plus · Nano X · Stax)
// variant="compact" → solo Nano X
// All links carry: target=_blank, rel="noopener noreferrer sponsored".
import React from "react";
import { i18nLedger, pickLang } from "../../i18n/ledger-affiliate";

const PRODUCTOS = [
  {
    id: "nano-s-plus",
    nombre: "Ledger Nano S Plus",
    precio: "€79",
    badgeKey: "mejorPrecio",
    color: "#00d4ff",
    path: "ledger-nano-s-plus",
    icono: "🔷",
    specs: {
      es: "USB-C · +5.500 activos · Sin Bluetooth",
      en: "USB-C · +5,500 assets · No Bluetooth",
      sk: "USB-C · +5 500 aktív · Bez Bluetooth", de: "USB-C · +5.500 Assets · Ohne Bluetooth", "zh-CN": "USB-C · +5,500 种资产 · 无蓝牙",
    },
  },
  {
    id: "nano-x",
    nombre: "Ledger Nano X",
    precio: "€149",
    badgeKey: "masVendida",
    color: "#f5a623",
    path: "ledger-nano-x",
    icono: "⭐",
    specs: {
      es: "Bluetooth · +5.500 activos · App móvil",
      en: "Bluetooth · +5,500 assets · Mobile app",
      sk: "Bluetooth · +5 500 aktív · Mobilná aplikácia", de: "Bluetooth · +5.500 Assets · Mobile App", "zh-CN": "蓝牙 · +5,500 种资产 · 移动应用",
    },
  },
  {
    id: "stax",
    nombre: "Ledger Stax",
    precio: "€279",
    badgeKey: "premium",
    color: "#9b59ff",
    path: "ledger-stax",
    icono: "💎",
    specs: {
      es: "Pantalla E-ink táctil · NFC · Diseño Tony Fadell",
      en: "E-ink touchscreen · NFC · Tony Fadell design",
      sk: "E-ink dotyková obrazovka · NFC · Tony Fadell dizajn", de: "Touchscreen E-Ink-Display · NFC · Design von Tony Fadell", "zh-CN": "E-ink 触摸屏 · NFC · Tony Fadell 设计",
    },
  },
];

const LedgerAffiliateCTA = ({ lang = "es", tracker, variant = "full" }) => {
  const L = ["es", "en", "sk", "de", "zh-CN"].includes(lang) ? lang : "en";
  const t = (key) => pickLang(i18nLedger[key], L);

  // COMPACT — solo Nano X
  if (variant === "compact") {
    const prod = PRODUCTOS[1];
    return (
      <div
        data-testid={`ledger-cta-compact-${tracker}`}
        style={{
          background: "rgba(0,212,255,.04)",
          border: "1px solid rgba(0,212,255,.15)",
          borderRadius: 10,
          padding: "14px 18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          flexWrap: "wrap",
          marginTop: 24,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 20 }}>🔷</span>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#f0f4ff" }}>
              {prod.nombre} — {prod.precio}
            </div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,.4)", marginTop: 2 }}>
              {pickLang(prod.specs, L)}
            </div>
          </div>
        </div>
        <a
          href={`https://shop.ledger.com/products/${prod.path}?r=eb740c0da9e0&tracker=${tracker}`}
          target="_blank"
          rel="noopener noreferrer sponsored"
          data-testid={`ledger-cta-compact-link-${tracker}`}
          style={{
            background: "linear-gradient(135deg,#f5a623,#e8941a)",
            color: "#07080f",
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: ".08em",
            padding: "8px 16px",
            borderRadius: 6,
            textDecoration: "none",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          {t("comprarEn")}
        </a>
      </div>
    );
  }

  // FULL — 3 productos
  return (
    <div
      data-testid={`ledger-cta-full-${tracker}`}
      style={{
        marginTop: 40,
        background: "linear-gradient(135deg,rgba(0,212,255,.04),rgba(245,166,35,.03))",
        border: "1px solid rgba(0,212,255,.18)",
        borderRadius: 14,
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "18px 22px 14px",
          borderBottom: "1px solid rgba(255,255,255,.06)",
        }}
      >
        <div
          style={{
            display: "inline-block",
            background: "rgba(245,166,35,.12)",
            border: "1px solid rgba(245,166,35,.3)",
            color: "#f5a623",
            fontSize: 9,
            letterSpacing: ".2em",
            padding: "3px 10px",
            borderRadius: 100,
            marginBottom: 6,
          }}
        >
          {t("ctaBadge")}
        </div>
        <div style={{ fontSize: 17, fontWeight: 700, color: "#f0f4ff" }}>
          {t("ctaTitulo")}
        </div>
        <div
          style={{
            fontSize: 12,
            color: "rgba(255,255,255,.5)",
            marginTop: 4,
            maxWidth: 480,
          }}
        >
          {t("ctaSubtitulo")}
        </div>
      </div>

      {/* Productos */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))",
          gap: 1,
          background: "rgba(255,255,255,.04)",
        }}
      >
        {PRODUCTOS.map((prod, idx) => (
          <div
            key={prod.id}
            style={{
              background: "#0a0b16",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                background: prod.color + "18",
                border: `1px solid ${prod.color}44`,
                color: prod.color,
                fontSize: 9,
                letterSpacing: ".15em",
                padding: "2px 8px",
                borderRadius: 100,
                width: "fit-content",
              }}
            >
              {prod.icono} {t(prod.badgeKey).toUpperCase()}
            </div>

            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#f0f4ff" }}>
                {prod.nombre}
              </div>
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 900,
                  color: prod.color,
                  marginTop: 2,
                }}
              >
                {prod.precio}
              </div>
            </div>

            <div
              style={{
                fontSize: 11,
                color: "rgba(255,255,255,.4)",
                lineHeight: 1.5,
              }}
            >
              {pickLang(prod.specs, L)}
            </div>

            <a
              href={`https://shop.ledger.com/products/${prod.path}?r=eb740c0da9e0&tracker=${tracker}`}
              target="_blank"
              rel="noopener noreferrer sponsored"
              data-testid={`ledger-cta-full-link-${prod.id}-${tracker}`}
              style={{
                marginTop: "auto",
                display: "block",
                textAlign: "center",
                background:
                  idx === 1 ? "linear-gradient(135deg,#f5a623,#e8941a)" : "none",
                border: idx === 1 ? "none" : `1px solid ${prod.color}55`,
                color: idx === 1 ? "#07080f" : prod.color,
                fontWeight: 700,
                fontSize: 12,
                letterSpacing: ".08em",
                padding: "9px 14px",
                borderRadius: 7,
                textDecoration: "none",
                transition: "all .2s",
              }}
            >
              {t("comprarEn")}
            </a>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "12px 22px",
          borderTop: "1px solid rgba(255,255,255,.06)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <p
          style={{
            fontSize: 10,
            color: "rgba(255,255,255,.35)",
            margin: 0,
            maxWidth: 480,
          }}
        >
          * {t("aviso")}
        </p>
        <a
          href={`https://shop.ledger.com/?r=eb740c0da9e0&tracker=${tracker}`}
          target="_blank"
          rel="noopener noreferrer sponsored"
          data-testid={`ledger-cta-full-vertodos-${tracker}`}
          style={{
            fontSize: 11,
            color: "rgba(0,212,255,.7)",
            textDecoration: "none",
            letterSpacing: ".05em",
            whiteSpace: "nowrap",
          }}
        >
          {t("verTodos")}
        </a>
      </div>
    </div>
  );
};

export default LedgerAffiliateCTA;
